import { getToken } from './api.js';

// Private documents need the login token, which a plain link can't send:
// fetch the file, then open it from a temporary blob URL.
export async function openPrivateFile(path) {
  const win = window.open('', '_blank'); // opened now, so pop-up blockers allow it
  const res = await fetch(`/api${path}`, { headers: { Authorization: `Bearer ${getToken()}` } });
  if (!res.ok) { win?.close(); throw new Error('download_failed'); }
  const url = URL.createObjectURL(await res.blob());
  if (win) win.location.href = url; else window.location.href = url;
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
